import { useEffect, useState } from 'react';

import { dialogService } from '@thefarmersfront/kitchen-mobile';

import { DIALOG_MESSAGES, DIALOG_TITLES } from '~/constants';
import { checkIsJsonString } from '~/utils';

import { TypeCheckInOutParams } from '../api';

/**
 * @description 공정 QR 스캔 후 결과 처리 훅
 * @return
 *  - openGongjeongQR : 공정 QR 스캔을 위해 카메라로 이동하는 브릿지
 *  - parsedScanData: 스캔한 데이터를 파싱한 값 (TypeCheckInOutParams | null)
 */
export const useScanGongjeongQR = () => {
  const [scanData, setScanData] = useState<string>('');
  const [parsedScanData, setParsedScanData] = useState<TypeCheckInOutParams | null>(null);

  const params = JSON.stringify({
    type: 'qr',
    title: 'QR 스캔',
  });

  useEffect(() => {
    window.onScanResult = handleScanResult;

    return () => {
      window.onScanResult = null;
    };
  }, []);

  useEffect(() => {
    /** 유효한 스캔 데이터가 존재할 경우, 체크인/아웃 API 요청 */
    if (scanData) {
      const checkInOutParams = JSON.parse(scanData);
      setParsedScanData(checkInOutParams);
    } else {
      setParsedScanData(null);
    }
  }, [scanData]);

  const openGongjeongQR = () => {
    setScanData('');

    if (window?.JSBridge) {
      window.JSBridge.moveToCapture(params);
    }

    if (window?.webkit) {
      window.webkit?.messageHandlers.moveToCapture.postMessage(params);
    }
  };

  const handleScanResult = (result: string) => {
    /** 스캔된 데이터가 빈 값일 때는 응답값 유효성 체크 X */
    if (!result) {
      return;
    }
    /** 스캔된 데이터가 유효한 Json 형태가 맞는지 체크한 후, 유효하지 않을 때 경고 토스트 표시 */
    if (!checkIsJsonString(result)) {
      dialogService.addDialog({
        title: DIALOG_TITLES.INVALID_QR_CODE,
        children: DIALOG_MESSAGES.INVALID_QR_CODE,
      });
      return;
    }
    setScanData(result);
  };

  return {
    openGongjeongQR,
    parsedScanData,
    setParsedScanData,
  };
};

export default useScanGongjeongQR;
